import { z } from 'zod'

// const rewardSchema = z.object({
// 	ratio: z
// 		.number({
// 			required_error: 'กรุณากรอกเปอร์เซ็นต์',
// 			invalid_type_error: 'กรุณากรอกเปอร์เซ็นต์',
// 		})
// 		.min(0, 'เปอร์เซ็นต์ต้องมากกว่าหรือเท่ากับ 0'),
// 	maximumCreditAmount: z
// 		.number({
// 			required_error: 'กรุณากรอกจำนวนเงินสูงสุด',
// 			invalid_type_error: 'กรุณากรอกจำนวนเงินสูงสุด',
// 		})
// 		.min(0, 'จำนวนเงินสูงสุดต้องมากกว่าหรือเท่ากับ 0')
// 		.optional()
// 		.nullable(),
// })

export const partnerFormSchema = z.object({
	nickname: z.string().min(1, 'กรุณากรอกชื่อ'),
	percentage: z
		.number({
			required_error: 'กรุณากรอกเปอร์เซ็นต์',
			invalid_type_error: 'กรุณากรอกเปอร์เซ็นต์',
		})
		.min(0, 'กรุณากรอกเปอร์เซ็นต์'),
	// rewards: z.record(rewardSchema),
})

export type PartnerFormValues = z.infer<typeof partnerFormSchema>
